import React from 'react'
import { useSelector } from 'react-redux'

import { getLanguage } from 'ducks/auth'
import { DeleteInterviewTemplateCategoryModal } from 'components/modals/DeleteInterviewTemplateCategoryModal/DeleteInterviewTemplateCategoryModal'
import { DeleteInterviewTemplateQuestionModal } from 'components/modals/DeleteInterviewTemplateQuestionModal/DeleteInterviewTemplateQuestionModal'
import { EditInterviewTemplateNameModal } from 'components/modals/EditInterviewTemplateNameModal/EditInterviewTemplateNameModal'
import { Box } from 'components/layout/Box/Box'
import { Loader } from 'components/shared/Loader/Loader'
import { Translate } from 'utils/translate'
import { Aside } from './layouts/Aside/Aside'
import { Header } from './layouts/Header/Header'
import { Main } from './layouts/Main/Main'

import {
  InterviewsCreatorHandlersContext,
  InterviewsCreatorStateContext,
} from './context'
import { useInternalState } from './hooks/useInternalState'

import styles from './Interviews.module.scss'

export const Interviews = ({ userName, uuid, dispatch }) => {
  const { state, handlers } = useInternalState({ uuid }, dispatch)
  const uiLanguage = useSelector(getLanguage)

  const {
    activeSection,
    templateName,
    isDeleteCategoryOpen,
    isDeleteQuestionOpen,
    isEditNameOpen,
    isFetching,
    skills,
  } = state
  const {
    handleDeleteCategoryClose,
    handleDeleteCategoryConfirm,
    handleDeleteQuestionClose,
    handleDeleteQuestionConfirm,
    handleEditNameClose,
    handleEditNameConfirm,
  } = handlers

  const { title = '' } = activeSection

  if (isFetching) {
    return <Loader isInline isFullScreen />
  }

  return (
    <InterviewsCreatorStateContext.Provider value={state}>
      <InterviewsCreatorHandlersContext.Provider value={handlers}>
        <Translate language={uiLanguage}>
          <Box className={styles.interviews} shouldWrapContent>
            <Header {...{ userName, uuid }} />
            <Box className={styles.content}>
              <Aside skills={skills} />
              <Main />
            </Box>
          </Box>
          <EditInterviewTemplateNameModal
            onCancel={handleEditNameClose}
            onClose={handleEditNameClose}
            onConfirm={handleEditNameConfirm}
            isOpen={isEditNameOpen}
            {...{ templateName }}
          />
          <DeleteInterviewTemplateCategoryModal
            category={title}
            onCancel={handleDeleteCategoryClose}
            onClose={handleDeleteCategoryClose}
            onConfirm={handleDeleteCategoryConfirm}
            isOpen={isDeleteCategoryOpen}
          />
          <DeleteInterviewTemplateQuestionModal
            onCancel={handleDeleteQuestionClose}
            onClose={handleDeleteQuestionClose}
            onConfirm={handleDeleteQuestionConfirm}
            isOpen={isDeleteQuestionOpen}
          />
        </Translate>
      </InterviewsCreatorHandlersContext.Provider>
    </InterviewsCreatorStateContext.Provider>
  )
}
